import { observer } from "mobx-react";
import React from "react";
import { withWSErrorContainer } from "../../../WSUtils/withWSErrorContainer";
import MessagePanel from "./MessagePanel";

interface OutboxTabContentProps {}

const OutboxTabContent: React.FC<OutboxTabContentProps> = withWSErrorContainer(
  observer(({}) => {
    return (
      <>
        {outboxData.map((data) => {
          const { date, name, id } = data;
          return (
            <MessagePanel
              key={id}
              date={date}
              name={name}
              fromTo="Til:"
              id={id}
            />
          );
        })}
      </>
    );
  })
);
export default OutboxTabContent;

export const outboxData = [
  {
    id: "1",
    date: "21.11.2022",
    name: "Navn Navnesen",
  },
  {
    id: "2",
    date: "21.11.2022",
    name: "Navn Navnesen",
  },
  {
    id: "3",
    date: "21.11.2022",
    name: "Navn Navnesen",
  },
  {
    id: "4",
    date: "21.11.2022",
    name: "Navn Navnesen",
  },

  {
    id: "5",
    date: "20.11.2022",
    name: "Navn Navnesen",
  },

  {
    id: "6",
    date: "19.11.2022",
    name: "Navn Navnesen",
  },
  {
    id: "7",
    date: "18.11.2022",
    name: "Navn Navnesen",
  },
  {
    id: "8",
    date: "17.11.2022",
    name: "Navn Navnesen",
  },
];
